export interface Chromosome {
    chrom_id: number;
    Gene_ID: string | null;
    Gene_description: string | null;
    Gene_name: string | null;
    Gene_GC: string | null;
    Gene_type: string | null;
    Strand: string | null;
    Phenotype: string | null;
    Study_reference: string | null;
    P_value: string | null;
    KEGG_ID: string | null;
    HGNC_symbol: string | null;
    Chromosome_name: string | null;
    Gene_start: string | null;
    Gene_end: string | null;
    WikiGene_description: string | null;
}

export interface GeneTypeDistribution {
    Gene_type: string;
    count: number;
}

export interface ChromosomeNameDistribution {
    Chromosome_name: string;
    count: number;
}

export const defaultChromosome: Chromosome = {
    chrom_id: 0,
    Gene_ID: null,
    Gene_description: null,
    Gene_name: null,
    Gene_GC: null,
    Gene_type: null,
    Strand: null,
    Phenotype: null,
    Study_reference: null,
    P_value: null,
    KEGG_ID: null,
    HGNC_symbol: null,
    Chromosome_name: null,
    Gene_start: null,
    Gene_end: null,
    WikiGene_description: null
};